import RecordingManager from './recordingManager';

class Stasher {
  recordingManager: RecordingManager;
  isRunning: boolean;
  events: any[][];

  constructor(recordingManager: RecordingManager) {
    this.recordingManager = recordingManager;
    this.isRunning = false;
    this.events = [];
  }

  start() {
    this.isRunning = true;
  }

  handle(event: any) {
    this.isInitializingEvent(event)
      ? this.events.push(event)
      : this.stop(event);
  }

  isInitializingEvent(event: { type: number }) {
    return (
      [2, 4].includes(event.type) ||
      this.isSelectionEvent(event) ||
      this.isConsoleEvent(event)
    );
  }

  isSelectionEvent(event: { type: any; data?: any }) {
    return event.type === 3 && event.data.source === 14;
  }

  isConsoleEvent(event: { type: any }) {
    return event.type === 6;
  }

  stop(event: any) {
    this.stamp(this.events, event.timestamp - 1);
    this.publish(...this.events, event);
    this.events = [];
    this.isRunning = false;
  }

  stamp(events: any[], timestamp: number) {
    events.forEach((event) => (event.timestamp = timestamp));
  }

  publish(...events: any[][][]) {
    events.forEach((event) => {
      this.recordingManager.publishEvent(event);
    });
  }
}

export default Stasher;
